import React, { useRef, useState } from "react";
import { inject, observer } from "mobx-react";
import { fn_setPrintCheckFlag } from "function/FnBodySetting";
import { Modal } from "components/modal/compound/Modal";
import { Button } from "components/ui/Button";
import { Radio, RadioGroup } from "components/ui/Radio";
import modalStore from "stores/ModalStore";

const PrintAddSelect = ({ rootStore }: { rootStore: any }) => {
  const { searchStore } = rootStore;
  const scrollContainerRef = useRef(null);

  const [scrollIndex, setScrollIndex] = useState<number>(0);
  const ITEM_HEIGHT = 54 as const;

  const selectData = searchStore.getPrintAddSelectVal;
  const viewType = selectData.title === "출력 속도 선택" ? "baudRateCheck" : "portCheck";
  const listCnt = selectData.list.length ?? 0;

  const scrollUp = () => {
    setScrollIndex(prevIndex => Math.max(0, prevIndex - 1));
  };

  const scrollDown = () => {
    const maxScrollIndex = listCnt > 7 ? listCnt - 7 : 0;
    setScrollIndex(prevIndex => Math.min(maxScrollIndex, prevIndex + 1));
  };

  // 취소 버튼 핸들러
  const handleCancel = () => {
    setScrollIndex(0);
    modalStore.closeModal("printAddSelect");
    searchStore.setPrintAddSelectVal(viewType, "0");
  };

  // 저장 버튼 핸들러
  const handleSave = () => {
    setScrollIndex(0);
    if (viewType === "baudRateCheck") {
      const element = document.getElementById("baudRate") as HTMLInputElement;
      if (element) {
        element.value = searchStore.getPrintAddSelectVal.baudRateCheck;
      }
    } else {
      const element = document.getElementById("port") as HTMLInputElement;
      if (element) {
        element.value = searchStore.getPrintAddSelectVal.portCheck;
      }
    }
    modalStore.closeModal("printAddSelect");
  };

  // 라디오 변경 핸들러
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    fn_setPrintCheckFlag(rootStore, event.target.value, viewType);
  };

  return (
    <Modal.BackGround containerWidth="374px" containerHeight="auto" border={true}>
      <Modal.Header title={selectData.title} onClose={handleCancel} />
      <div id="printScrollTop" ref={scrollContainerRef} className="flex flex-col gap-4 p-4">
        <div className="overflow-hidden relative h-[384px]">
          <div
            className="scroll-list transition-transform duration-300 ease-in-out"
            style={{ transform: `translateY(-${scrollIndex * ITEM_HEIGHT}px)` }}
          >
            <RadioGroup name="portName" value={searchStore.getPrintAddSelectVal[viewType]} onChange={handleRadioChange}>
              {selectData.list.map((item: string) => (
                <Radio key={item} id={`item-${item}`} name="portName" value={item} label={item} />
              ))}
            </RadioGroup>
          </div>
        </div>

        {/* 페이징 */}
        {listCnt > 7 && (
          <Modal.Bottom className="!p-0">
            <Button variant={scrollIndex === 0 ? "disabled" : "white"} type="button" onClick={scrollUp}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className={`w-8 h-8 font-bold ${scrollIndex === 0 ? "text-gray-600" : "text-black"}`}
              >
                <path
                  fillRule="evenodd"
                  d="M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z"
                  clipRule="evenodd"
                />
              </svg>
            </Button>
            <Button variant={scrollIndex === listCnt - 7 ? "disabled" : "white"} type="button" onClick={scrollDown}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className={`w-8 h-8 font-bold ${scrollIndex === listCnt - 7 ? "text-gray-600" : "text-black"}`}
              >
                <path
                  fillRule="evenodd"
                  d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z"
                  clipRule="evenodd"
                />
              </svg>
            </Button>
          </Modal.Bottom>
        )}
        <Modal.Divider className="!my-2 !mx-0" />
        <Modal.Bottom className="!p-0">
          <Button variant="white" size="sm" onClick={handleCancel} className="!font-bold">
            취소
          </Button>
          <Button variant="default" size="sm" onClick={handleSave} className="!font-bold">
            저장
          </Button>
        </Modal.Bottom>
      </div>
    </Modal.BackGround>
  );
};

export default inject("rootStore")(observer(PrintAddSelect));
